import LeadReport from "../pages/lead/LeadReport";
import EmployeeReview from "./../components/features/dashboards/dashboardl4/employee/EmployeeReview";
import EditLead from "../pages/lead/EditLead";
import AddGroup from "./../pages/settings/AddGroup";
import ServiceType from "./../pages/settings/ServiceType";
import Source from "./../pages/settings/Source";
import Status from "./../pages/settings/Status";
import Tax from "./../pages/settings/Tax";
import Employees from "./../pages/settings/Employees";
import Departments from "./../pages/settings/Departments";
import LeadType from "./../pages/settings/LeadType";
import LeadReport11 from "./../pages/lead/LeadReport11";
import AddLeadL1 from "../pages/lead/AddLead";
import ClientRatingDashboardL3 from "./../components/features/dashboards/dashboardl3/clientrating/ClientRatingDashboardL3";
import MyRequests from "../pages/Operations/Operationperson/MyRequests";
import Dashboard from "../pages/dashboard/Dashboard";
import Finance from "../pages/finance/Finance";
import ClientMaster from "./../pages/settings/ClientMaster";
import AddClients from "../pages/settings/AddClients";
import AddProjects from "../pages/settings/AddProjects";
import MyMember from "../pages/settings/MyMember";
import HourlyRates from "../pages/settings/HourlyRates";
import GandATax from "../pages/settings/GandATax";
import Hardware from "../pages/settings/Hardware";
import CompanyProfile from "../pages/settings/CompanyProfile"
import QuotationTemplate from "../pages/settings/QuotationTemplate"
import SalesPresalesOperations from "../pages/Operations/SalesOperations/SaleOperation/ProjectRequest/SalesPresalesOperations";
import ExpIncomeL2 from "../components/features/finance/financel2/ExpIncomeL2";
import FinancialPiechartL2 from './../components/features/finance/financel2/FinancialPiechartL2';
import ProjectFinancialL2 from './../components/features/finance/financel2/ProjectFinancialL2';
import FinancialL2 from "../pages/finance/FinanceOldL2.jsx/FinancialL2";
import HourlyRatesManager from "../pages/settings/HourlyRatesManager"
import FinanceTax from "../pages/settings/FinanceTax"
import Inventory from "../pages/settings/Inventory";
import NewProjectDash from "../pages/Wizard/NewProjectWizard/NewProjectDash";
import Assembly from "../pages/settings/Assembly";
import Subparts from "../pages/settings/Subparts";
import OperationGroup from "../pages/settings/OperationGroup";
import settingGroup from "../pages/settings/SettingGroup";
import ProjectManager from "../pages/Operations/OperationParent/ProjectManager";

export const routeComponentMap = {
  "": Dashboard,
  "/dashboard/add-lead": AddLeadL1,
  "/dashboard/edit-lead/:id": EditLead,
  "/dashboard/leadreport": LeadReport,
  "/dashboard/lead-report": LeadReport11,
  "/dashboard/finance": Finance,
  "/dashboard/wizard": NewProjectDash,


  "/dashboard/add-group": AddGroup,
  "/dashboard/service-types": ServiceType,
  "/dashboard/source": Source,
  "/dashboard/status": Status,
  "/dashboard/client-master": ClientMaster,
  "/dashboard/tax": Tax,
  "/dashboard/finance-tax": FinanceTax,
  "/dashboard/my-member": MyMember,
  "/dashboard/hourly-rates": HourlyRates,
  "/dashboard/hourly-rates-manager": HourlyRatesManager,

  "/dashboard/g-a-tax": GandATax,
  "/dashboard/hardware": Hardware,
  "/dashboard/company-profile": CompanyProfile,
  "/dashboard/quotation-template": QuotationTemplate,
  "/dashboard/finance1": ExpIncomeL2,
  "/dashboard/finance2": FinancialPiechartL2,
  "/dashboard/finance3": ProjectFinancialL2,
  "/dashboard/financesummary": FinancialL2,

  "/dashboard/inventory": Inventory,
  "/dashboard/assembly": Assembly,
  "/dashboard/subparts": Subparts,
  "/dashboard/group": OperationGroup,
  "/dashboard/addgroup": settingGroup,


  "/dashboard/employees": Employees,
  "/dashboard/departments": Departments,
  "/dashboard/lead-types": LeadType,
  "/dashboard/add-client": AddClients,
  "/dashboard/add-project": AddProjects,

  "/dashboard/client-ratings": ClientRatingDashboardL3,
  "/dashboard/operations": SalesPresalesOperations,

  "/dashboard/project-manager": ProjectManager,
  "/dashboard/employee-review": EmployeeReview,
  "/dashboard/operation-person": MyRequests,

};

